import useSalonAcceptanceGalleryController from "@general/api/useSalonAcceptanceGalleryController"
import useRedirectIfNotFound from "@hooks/useRedirectIfNotFound"
import { useQuery } from "@tanstack/react-query"

export default function useAcceptancesQuery(slug: string, sectionId: string | undefined) {
    const controller = useSalonAcceptanceGalleryController()

    const acceptances = useQuery(
        ['general', 'acceptances', 'gallery', slug, sectionId], 
        () =>  controller.show(slug, sectionId).request(), 
        { staleTime: Infinity, retry: false }
    )

    useRedirectIfNotFound(acceptances);

    return acceptances;
}